import {ParamsModel} from 'src/app/modules/common/Model'
import {actionTypes} from './constants'

export const actions = {
  getFdTenure: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_FD_TENURE_START,
    payload: params,
  }),

  getFdTenureSuccess: (data: any) => ({
    type: actionTypes.GET_FD_TENURE_SUCCESS,
    payload: data,
  }),
  getFdTenureFinish: () => ({
    type: actionTypes.GET_FD_TENURE_FINISH,
  }),
  getFdTenureError: (error: unknown) => ({
    type: actionTypes.GET_FD_TENURE_FINISH,
    payload: {error},
  }),

  addFdTenure: (data: any) => ({
    type: actionTypes.ADD_FD_TENURE_START,
    payload: data,
  }),
  addFdTenureSuccess: (task: any) => ({
    type: actionTypes.ADD_FD_TENURE_SUCCESS,
    payload: task,
  }),
  addFdTenureFinish: () => ({
    type: actionTypes.ADD_FD_TENURE_FINISH,
  }),
  addFdTenureReset: () => ({
    type: actionTypes.ADD_FD_TENURE_RESET,
  }),

  updateFdTenure: (data: any, id: string) => ({
    type: actionTypes.UPDATE_FD_TENURE_START,
    payload: {data, id},
  }),
  updateFdTenureSuccess: (task: any) => ({
    type: actionTypes.UPDATE_FD_TENURE_SUCCESS,
    payload: task,
  }),
  updateFdTenureFinish: () => ({
    type: actionTypes.UPDATE_FD_TENURE_FINISH,
  }),
  updateFdTenureReset: () => ({
    type: actionTypes.UPDATE_FD_TENURE_RESET,
  }),

  deleteFdTenure: (data: any) => ({
    type: actionTypes.DELETE_FD_TENURE_START,
    payload: {fdTenureId: data},
  }),
  deleteFdTenureSuccess: (data: any) => ({
    type: actionTypes.DELETE_FD_TENURE_SUCCESS,
    payload: data,
  }),
  deleteFdTenureFinish: () => ({
    type: actionTypes.DELETE_FD_TENURE_FINISH,
  }),
  activateFdTenure: (id: any) => ({
    type: actionTypes.SINGLE_ACTIVATE_FD_TENURE_REQUEST,
    payload: {fdTenureId: id},
  }),
  deactivateFdTenure: (id: any) => ({
    type: actionTypes.SINGLE_DEACTIVATE_FD_TENURE_REQUEST,
    payload: {fdTenureId: id},
  }),
  singleActivateFdTenure: (id: any) => ({
    type: actionTypes.SINGLE_ACTIVATE_FD_TENURE_REQUEST,
    payload: {fdTenureId: [id]},
  }),
  singleDeactivateFdTenure: (id: any) => ({
    type: actionTypes.SINGLE_DEACTIVATE_FD_TENURE_REQUEST,
    payload: {fdTenureId: [id]},
  }),
}
